export default __webpack_public_path__ + "static/media/395b47fd7c0f81bd.bc8ab713f4bb7e90bc3ce36ad15d7a5e.svg";